import { LocalizedLink as Link } from '../components/LocalizedLink';
import { useEffect } from 'react';
import SEO from '../components/SEO';
import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';
import './LegalPage.css';
import { useTranslation } from "react-i18next";

export default function CookiePolicyPage() {
    const { t } = useTranslation();
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="legal-page">
      <SEO 
        title={t('common.cookiePolicy')}
        description="Understand how Reviio uses cookies and similar technologies to provide our service."

      />
      <SiteHeader variant="solid" />

      <div className="legal-container">
        <div className="legal-header">
          <h1>{t('common.cookiePolicy')}</h1>
          <p className="legal-meta">
            <strong>{t('common.effectiveDate')}</strong>{' ' + t('common.june222026NbspNbsp')}<strong>{t('common.lastUpdated')}</strong>{' ' + t('common.june222026')}</p>
        </div>

        <div className="legal-toc">
          <h4>{t('common.tableOfContents')}</h4>
          <ol>
            <li><a href="#cp-1">{t('legal.cookie.whatAreCookies')}</a></li>
            <li><a href="#cp-2">{t('legal.cookie.howWeUseCookies')}</a></li>
            <li><a href="#cp-3">{t('legal.cookie.typesOfCookiesWeUse')}</a></li>
            <li><a href="#cp-4">{t('legal.cookie.detailedCookieInventory')}</a></li>
            <li><a href="#cp-5">{t('legal.cookie.thirdPartyCookies')}</a></li>
            <li><a href="#cp-6">{t('legal.cookie.managingAmpDisablingCookies')}</a></li>
            <li><a href="#cp-7">{t('legal.cookie.cookieConsent')}</a></li>
            <li><a href="#cp-8">{t('common.changesToThisPolicy')}</a></li>
            <li><a href="#cp-9">{t('common.contactUs')}</a></li>
          </ol>
        </div>

        <div className="legal-content">

          <h2 id="cp-1">{t('legal.cookie.1WhatAreCookies')}</h2>
          <p>{' ' + t('legal.cookie.cookiesAreSmallTextFilesThat')}</p>
          <p>{' ' + t('legal.cookie.cookiesMayBeSetByThe')}</p>
          <p>{' ' + t('legal.cookie.inAdditionToCookiesWeMay')}</p>

          <h2 id="cp-2">{t('legal.cookie.2HowWeUseCookies')}</h2>
          <p>{t('legal.cookie.reviioUsesCookiesAndSimilarTechnologies')}</p>
          <ul>
            <li><strong>{t('legal.cookie.authenticationAmpSecurity')}</strong>{' ' + t('legal.cookie.toIdentifyYouWhenYouLog')}</li>
            <li><strong>{t('legal.cookie.preferencesAmpSettings')}</strong>{' ' + t('legal.cookie.toRememberYourPreferencesSuchAs')}</li>
            <li><strong>{t('legal.cookie.functionality')}</strong>{' ' + t('legal.cookie.toEnableCoreFeaturesOfThe')}</li>
            <li><strong>{t('legal.cookie.performanceAmpAnalytics')}</strong>{' ' + t('legal.cookie.toUnderstandHowVisitorsUseOur')}</li>
          </ul>

          <div className="legal-callout">
            <p>
              <strong>{t('common.important')}</strong>{' ' + t('legal.cookie.reviioDoes')}<strong>{t('common.not')}</strong>{' ' + t('legal.cookie.useCookiesForAdvertisingBehavioralProfil')}</p>
          </div>

          <h2 id="cp-3">{t('legal.cookie.3TypesOfCookiesWeUse')}</h2>

          <table>
            <thead>
              <tr>
                <th>{t('common.category')}</th>
                <th>{t('common.purpose')}</th>
                <th>{t('legal.cookie.required')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>{t('legal.cookie.strictlyNecessary')}</strong></td>
                <td>{t('legal.cookie.essentialForTheWebsiteToFunction')}</td>
                <td>{t('legal.cookie.yesMdashCannotBeDisabled')}</td>
              </tr>
              <tr>
                <td><strong>{t('legal.cookie.functional')}</strong></td>
                <td>{t('legal.cookie.rememberYourPreferencesAndSettingsE')}</td>
                <td>{t('legal.cookie.optional')}</td>
              </tr>
              <tr>
                <td><strong>{t('legal.cookie.performanceAnalytics')}</strong></td>
                <td>{t('legal.cookie.collectAnonymizedAggregatedDataAboutHow')}</td>
                <td>{t('legal.cookie.optional')}</td>
              </tr>
            </tbody>
          </table>

          <p>{' ' + t('legal.cookie.weDo')}<strong>{t('common.not')}</strong>{' ' + t('legal.cookie.useAnyLdquoMarketingAdvertisingRdquo')}</p>

          <h2 id="cp-4">{t('legal.cookie.4DetailedCookieInventory')}</h2>

          <h3>{t('legal.cookie.41StrictlyNecessaryCookies')}</h3>
          <table>
            <thead>
              <tr>
                <th>{t('legal.cookie.cookieName')}</th>
                <th>{t('legal.cookie.provider')}</th>
                <th>{t('common.purpose')}</th>
                <th>{t('legal.cookie.duration')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><code>{t('legal.cookie.accessToken')}</code></td>
                <td>{t('common.reviio')}</td>
                <td>{t('legal.cookie.storesTheJwtAccessTokenFor')}</td>
                <td>{t('legal.cookie.session15Ndash30Minutes')}</td>
              </tr>
              <tr>
                <td><code>{t('legal.cookie.refreshToken')}</code></td>
                <td>{t('common.reviio')}</td>
                <td>{t('legal.cookie.usedToObtainANewAccess')}</td>
                <td>{t('legal.cookie.7Ndash30Days')}</td>
              </tr>
              <tr>
                <td><code>{t('legal.cookie.csrfToken')}</code></td>
                <td>{t('common.reviio')}</td>
                <td>{t('legal.cookie.protectsAgainstCrossSiteRequestForgery')}</td>
                <td>{t('legal.cookie.session')}</td>
              </tr>
              <tr>
                <td><code>{t('legal.cookie.sessionId')}</code></td>
                <td>{t('common.reviio')}</td>
                <td>{t('legal.cookie.identifiesYourBrowserSessionOnThe')}</td>
                <td>{t('legal.cookie.session')}</td>
              </tr>
              <tr>
                <td><code>{t('legal.cookie.cookieConsent2')}</code></td>
                <td>{t('common.reviio')}</td>
                <td>{t('legal.cookie.recordsYourCookieConsentPreferencesSo')}</td>
                <td>{t('legal.cookie.12Months')}</td>
              </tr>
            </tbody>
          </table>

          <h3>{t('legal.cookie.42FunctionalCookies')}</h3>
          <table>
            <thead>
              <tr>
                <th>{t('legal.cookie.cookieStorageKey')}</th>
                <th>{t('legal.cookie.provider')}</th>
                <th>{t('common.purpose')}</th>
                <th>{t('legal.cookie.duration')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><code>{t('legal.cookie.uiTheme')}</code></td>
                <td>{t('common.reviio')}</td>
                <td>{t('legal.cookie.storesYourSelectedThemePreferenceLight')}</td>
                <td>{t('legal.cookie.persistentLocalStorage')}</td>
              </tr>
              <tr>
                <td><code>{t('legal.cookie.uiLanguage')}</code></td>
                <td>{t('common.reviio')}</td>
                <td>{t('legal.cookie.storesYourPreferredUiLanguageFor')}</td>
                <td>{t('legal.cookie.persistentLocalStorage')}</td>
              </tr>
              <tr>
                <td><code>{t('legal.cookie.sidebarCollapsed')}</code></td>
                <td>{t('common.reviio')}</td>
                <td>{t('legal.cookie.remembersWhetherYouCollapsedTheDashboard')}</td>
                <td>{t('legal.cookie.persistentLocalStorage')}</td>
              </tr>
              <tr>
                <td><code>{t('legal.cookie.selectedLocation')}</code></td>
                <td>{t('common.reviio')}</td>
                <td>{t('legal.cookie.remembersYourLastViewedLocationSo')}</td>
                <td>{t('legal.cookie.sessionSessionStorage')}</td>
              </tr>
            </tbody>
          </table>

          <h3>{t('legal.cookie.43PerformanceAnalyticsCookies')}</h3>
          <table>
            <thead>
              <tr>
                <th>{t('legal.cookie.cookieName')}</th>
                <th>{t('legal.cookie.provider')}</th>
                <th>{t('common.purpose')}</th>
                <th>{t('legal.cookie.duration')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><code>{t('legal.cookie.ga')}</code>, <code>{t('legal.cookie.ga2')}</code></td>
                <td>{t('legal.cookie.googleAnalytics')}</td>
                <td>{t('legal.cookie.usedToDistinguishUniqueUsersAnd')}</td>
                <td>{t('legal.cookie.upTo2Years')}</td>
              </tr>
              <tr>
                <td><code>{t('legal.cookie.gid')}</code></td>
                <td>{t('legal.cookie.googleAnalytics')}</td>
                <td>{t('legal.cookie.usedToDistinguishUsersForAggregated')}</td>
                <td>{t('legal.cookie.24Hours')}</td>
              </tr>
            </tbody>
          </table>

          <p>{' ' + t('legal.cookie.analyticsCookiesAreOnlySetAfter')}</p>

          <h2 id="cp-5">{t('legal.cookie.5ThirdPartyCookies')}</h2>
          <p>{' ' + t('legal.cookie.someCookiesOnOurWebsiteAre')}</p>

          <table>
            <thead>
              <tr>
                <th>{t('common.thirdParty')}</th>
                <th>{t('common.purpose')}</th>
                <th>{t('common.category')}</th>
                <th>{t('common.privacyPolicy')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>{t('legal.cookie.googleAnalytics')}</strong></td>
                <td>{t('legal.cookie.aggregatedAnonymizedWebsiteUsageAnalytic')}</td>
                <td>{t('legal.cookie.performanceAnalytics')}</td>
                <td><a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">{t('legal.cookie.googlePrivacyPolicy')}</a></td>
              </tr>
              <tr>
                <td><strong>{t('legal.cookie.googleOauth')}</strong></td>
                <td>{t('legal.cookie.duringTheGoogleBusinessProfileConnection')}</td>
                <td>{t('legal.cookie.strictlyNecessaryDuringOauthFlowOnly')}</td>
                <td><a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">{t('legal.cookie.googlePrivacyPolicy')}</a></td>
              </tr>
              <tr>
                <td><strong>{t('common.cybersourceVisa')}</strong></td>
                <td>{t('legal.cookie.duringThePaymentCheckoutFlowCybersource')}</td>
                <td>{t('legal.cookie.strictlyNecessaryDuringPaymentFlowOnly')}</td>
                <td><a href="https://www.visa.com/privacy" target="_blank" rel="noopener noreferrer">{t('legal.cookie.visaPrivacyPolicy')}</a></td>
              </tr>
            </tbody>
          </table>

          <p>{' ' + t('legal.cookie.weDoNotUseCookiesFrom')}</p>

          <h2 id="cp-6">{t('legal.cookie.6ManagingAmpDisablingCookies')}</h2>
          <p>{' ' + t('legal.cookie.youHaveSeveralOptionsForManaging')}</p>

          <h3>{t('legal.cookie.61ThroughOurCookieBanner')}</h3>
          <p>{' ' + t('legal.cookie.whenYouFirstVisitOurWebsite')}</p>

          <h3>{t('legal.cookie.62ThroughYourBrowserSettings')}</h3>
          <p>{' ' + t('legal.cookie.mostWebBrowsersAllowYouTo')}</p>
          <ul>
            <li>{t('legal.cookie.viewWhatCookiesAreStoredOn')}</li>
            <li>{t('legal.cookie.deleteIndividualCookiesOrAllCookies')}</li>
            <li>{t('legal.cookie.blockCookiesFromSpecificWebsitesOr')}</li>
            <li>{t('legal.cookie.blockThirdPartyCookiesWhileAllowing')}</li>
            <li>{t('legal.cookie.setYourBrowserToNotifyYou')}</li>
          </ul>
          <p>{' ' + t('legal.cookie.hereAreLinksToCookieManagement')}</p>
          <ul>
            <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">{t('legal.cookie.googleChrome')}</a></li>
            <li><a href="https://support.mozilla.org/en-US/kb/enhanced-tracking-protection-firefox-desktop" target="_blank" rel="noopener noreferrer">{t('legal.cookie.mozillaFirefox')}</a></li>
            <li><a href="https://support.apple.com/guide/safari/manage-cookies-sfri11471" target="_blank" rel="noopener noreferrer">{t('legal.cookie.appleSafari')}</a></li>
            <li><a href="https://support.microsoft.com/en-us/microsoft-edge/manage-cookies-in-microsoft-edge-168dab11-0753-043d-7c16-ede5947fc64d" target="_blank" rel="noopener noreferrer">{t('legal.cookie.microsoftEdge')}</a></li>
          </ul>

          <h3>{t('legal.cookie.63GoogleAnalyticsOptOut')}</h3>
          <p>{' ' + t('legal.cookie.youCanOptOutOfGoogle')}{' '}
            <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">{t('legal.cookie.googleAnalyticsOptOutBrowserAdd')}</a>.
          </p>

          <div className="legal-callout">
            <p>
              <strong>{t('legal.cookie.note')}</strong>{' ' + t('legal.cookie.disablingStrictlyNecessaryCookiesMayPrev')}</p>
          </div>

          <h2 id="cp-7">{t('legal.cookie.7CookieConsent')}</h2>
          <p>{' ' + t('legal.cookie.inAccordanceWithApplicableDataProtection')}</p>
          <ul>
            <li><strong>{t('legal.cookie.strictlyNecessaryCookies')}</strong>{' ' + t('legal.cookie.doNotRequireConsentAsThey')}</li>
            <li><strong>{t('legal.cookie.functionalAndAnalyticsCookies')}</strong>{' ' + t('legal.cookie.areOnlySetAfterYouProvide')}</li>
            <li>{t('legal.cookie.youCanWithdrawYourConsentAt')}</li>
            <li>{t('legal.cookie.yourConsentPreferenceIsStoredIn')}<code>{t('legal.cookie.cookieConsent2')}</code>{' ' + t('legal.cookie.cookieFor12MonthsAfterThat')}</li>
          </ul>

          <h2 id="cp-8">{t('legal.cookie.8ChangesToThisPolicy')}</h2>
          <p>{' ' + t('legal.cookie.weMayUpdateThisCookiePolicy')}</p>
          <p>{' ' + t('legal.cookie.weEncourageYouToReviewThis')}</p>

          <h2 id="cp-9">{t('legal.cookie.9ContactUs')}</h2>
          <p>{' ' + t('legal.cookie.ifYouHaveQuestionsOrConcerns')}</p>
          <ul>
            <li><strong>{t('common.email2')}</strong> <a href="mailto:admin@reviio.app">{t('common.adminReviioApp')}</a></li>
            <li><strong>{t('common.generalSupport')}</strong> <a href="mailto:support@reviio.app">{t('common.supportReviioApp')}</a></li>
            <li><strong>{t('common.website')}</strong> <a href="https://reviio.com">{t('common.httpsReviioCom')}</a></li>
          </ul>
          <p>{' ' + t('legal.cookie.forMoreInformationAboutHowWe')}<Link to="/privacy-policy">{t('common.privacyPolicy')}</Link>.
          </p>

        </div>
      </div>

      <SiteFooter />
    </div>
  );
}
